<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-cover">
<h1>About the Cover</h1>
<p>Following the death of her husband, a Saxon Earl more than twice her age, a young Norman lady of noble birth is allowed to return to her home in France. But that journey is fraught with danger. Conspiracy, family secrets, stolen jewellery and a raid by Welsh brigands from across the border all conspire against her. Arrested and thrown into dungeon and then threatened with torture, she is made to stand trial for theft and murder.</p>
<p>This is a medieval mystery of epic proportions, full of twists and turns, and culminating in the trial of Lady Adela Fitzgerald. But can the arrival of the king's royal falconer unravel the mysteries and prove the innocence of the Norman lady before it is too late? Can he save her from the gallows?</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?6314ad29